import { ApiErrorMessageWithTrans } from '@components/Error/ApiErrorMessageWithTrans';
import { CustomerLoginModal } from '@components/Login/CustomerLoginModal';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { NoddiButton, noddiToast } from 'noddi-ui-web';
import { downloadOrderReceipt, useAuthContext } from 'noddi-web';
import { useEffect, useState } from 'react';

interface DownloadOrderReceiptButtonProps {
  orderId: number;
}

export const DownloadOrderReceiptButton = ({ orderId }: DownloadOrderReceiptButtonProps) => {
  const { isLoggedIn } = useAuthContext();
  const [openLoginModal, setOpenLoginModal] = useState(false);

  const {
    data: order,
    isLoading: isOrderLoading,
    error: orderError,
    refetch: getOrder
  } = noddiAsync.useGet({
    type: URLKeys.getOrderCustomer,
    input: {
      orderId
    },
    queryConfig: {
      enabled: false
    }
  });

  useEffect(() => {
    if (order) {
      if (order.receipts.length === 0) {
        noddiToast.error(t`No receipts found for this order`);
        return;
      }
      downloadOrderReceipt(order.receipts);
    }
  }, [order?.receipts, order]);

  return (
    <div className='flex flex-col'>
      {orderError && (
        <div className='mb-3'>
          <ApiErrorMessageWithTrans error={orderError} />
        </div>
      )}

      <NoddiButton
        loading={isOrderLoading}
        startIcon='Download'
        variant='outline'
        className='w-full md:w-fit'
        // oxlint-disable-next-line typescript/no-misused-promises -- async onClick runs getOrder(); React discards the returned promise, so a rejection is unhandled unless the body catches
        onClick={async () => {
          isLoggedIn ? await getOrder() : setOpenLoginModal(true);
        }}
      >
        <Trans>Download receipt</Trans>
      </NoddiButton>
      <CustomerLoginModal
        open={openLoginModal}
        onClose={() => setOpenLoginModal(false)}
        // oxlint-disable-next-line typescript/no-misused-promises -- async onLoginSuccess runs getOrder(); React discards the returned promise, so a rejection is unhandled unless the body catches
        onLoginSuccess={async () => {
          await getOrder();
        }}
      />
    </div>
  );
};
